export const API_STATUS_KEYS = {
    OPEN: "Åpen",
    IN_PROGRESS: "Under arbeid",
    IMMEDIATE_ACTION_TAKEN: "Strakstiltak utført",
    COMPLETED: "Fullført",
    CLOSED: "Lukket",
} as const;

export type ApiStatusKey = (typeof API_STATUS_KEYS)[keyof typeof API_STATUS_KEYS];

export type StatusVisualColor = "green" | "pink" | "teal-dark" | "greige" | "greige-dark";

export const STATUS_COLORS: Record<string, StatusVisualColor> = {
    [API_STATUS_KEYS.OPEN]: "green",
    [API_STATUS_KEYS.IN_PROGRESS]: "green",
    [API_STATUS_KEYS.IMMEDIATE_ACTION_TAKEN]: "pink",
    [API_STATUS_KEYS.COMPLETED]: "teal-dark",
    [API_STATUS_KEYS.CLOSED]: "greige-dark",
};

const DOT_BG_BY_COLOR: Record<StatusVisualColor, string> = {
    green: "bg-chameleon-green",
    pink: "bg-chameleon-pink",
    "teal-dark": "bg-surface-teal-dark",
    greige: "bg-compendia-greige",
    "greige-dark": "bg-compendia-greige-dark",
};

export const ORDERED_STATUSES = [
    {
        apiKey: API_STATUS_KEYS.OPEN,
        translationKey: "common.issueStatus.open",
    },
    {
        apiKey: API_STATUS_KEYS.IN_PROGRESS,
        translationKey: "common.issueStatus.inProgress",
    },
    {
        apiKey: API_STATUS_KEYS.IMMEDIATE_ACTION_TAKEN,
        translationKey: "common.issueStatus.immediateActionTaken",
    },
    {
        apiKey: API_STATUS_KEYS.COMPLETED,
        translationKey: "common.issueStatus.completed",
    },
    {
        apiKey: API_STATUS_KEYS.CLOSED,
        translationKey: "common.issueStatus.closed",
    },
] as const;

export const getStatusColorByApiKey = (apiKey: string): StatusVisualColor => {
    return STATUS_COLORS[apiKey] ?? "greige";
};

export const getStatusDotClassByApiKey = (apiKey: string): string => {
    return DOT_BG_BY_COLOR[getStatusColorByApiKey(apiKey)];
};

export const isActiveStatus = (apiKey: string): boolean => {
    return apiKey !== API_STATUS_KEYS.CLOSED;
};
